import * as React from "react";

export interface IDrupalGenealogyPageProps {}

export const DrupalGenealogyPage: React.FunctionComponent<IDrupalGenealogyPageProps> = () => {
  return <div style={{ marginTop: "20rem" }}>Work in progress</div>;
};
